/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filesdropsubtitle2Inputs */

const en_filesdropsubtitle2 = /** @type {(inputs: Filesdropsubtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contracts, invoices, receipts, photos, WhatsApp .txt — up to 25 MB each`)
};

const pt_filesdropsubtitle2 = /** @type {(inputs: Filesdropsubtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contratos, faturas, recibos, fotos, .txt do WhatsApp — até 25 MB cada`)
};

/**
* | output |
* | --- |
* | "Contracts, invoices, receipts, photos, WhatsApp .txt — up to 25 MB each" |
*
* @param {Filesdropsubtitle2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const filesdropsubtitle2 = /** @type {((inputs?: Filesdropsubtitle2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filesdropsubtitle2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_filesdropsubtitle2(inputs)
	return pt_filesdropsubtitle2(inputs)
});
export { filesdropsubtitle2 as "filesDropSubtitle" }